import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18h-7l7 -7h-7","key":"svg-0"}],["path",{"d":"M17 18v-13","key":"svg-1"}],["path",{"d":"M14 14.5l6 -3.5","key":"svg-2"}]]

/**
 * IconCurrencyZloty
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktemxvdHkiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDE4aC03bDcgLTdoLTciIC8+CiAgPHBhdGggZD0iTTE3IDE4di0xMyIgLz4KICA8cGF0aCBkPSJNMTQgMTQuNWw2IC0zLjUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/currency-zloty
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyZloty = createReactComponent('outline', 'currency-zloty', 'CurrencyZloty', __iconNode);

export default IconCurrencyZloty;